import React, { FC } from 'react';
import { IOrderSimulation } from 'src/graphql/types';
import styled from 'styled-components';
import { Table, TH } from '../../../components/table/table';
import { White } from '../../../styles/colours';
import { OrderSimulationTableBody } from './table-body';

const StyledOrderSimulationTable = styled(Table)`
  background-color: ${White};
  border-radius: 0.25rem;
`;

interface IOrderSimulationTableProps {
  orderSimulation: IOrderSimulation;
}

const OrderSimulationTable: FC<IOrderSimulationTableProps> = ({
  orderSimulation,
}) => (
  <StyledOrderSimulationTable>
    <thead>
      <tr>
        <TH align="left">#</TH>
        <TH align="left">Desired quantity</TH>
        <TH align="left">Confirmed quantity</TH>
        <TH align="left">Unit of measure</TH>
        <TH align="left">Delivery lead date</TH>
        <TH align="left">Actual delivery date</TH>
        <TH align="left">Backordered quantity</TH>
        <TH align="left">Backordered</TH>
      </tr>
    </thead>
    <OrderSimulationTableBody orderSimulation={orderSimulation} />
  </StyledOrderSimulationTable>
);

export { OrderSimulationTable };
